// tokens/motion.json: three durations (fast 120, base 220, slow 480) and one
// curve (ease-out). Web CSS transition strings are composed here from the
// generated tokens; the native Reanimated presets live in tamagui.config.ts.
//
// Scoped to the properties that actually change, not `all`: Tamagui's web
// driver defaults an unset `transition` to `all <duration>`, which declares
// padding and layout as transitioned (a reflow risk detectors rightly flag).
import type { TransitionProp } from 'tamagui';

import { duration, easing } from './tokens.generated';

const FAST = `${duration.fast}ms cubic-bezier(${easing.easeOut.join(', ')})`;

// Tamagui accepts a raw CSS transition string inside a pseudo-style at runtime,
// but TransitionProp only types the registered preset names, hence the cast.
export const MICRO_TRANSITION = `background-color ${FAST}, border-color ${FAST}` as TransitionProp;
export const MICRO_TRANSITION_BORDER = `border-color ${FAST}` as TransitionProp;
// Press moves 1px: no scale and no spring.
export const PRESS_TRANSITION = `transform ${FAST}, background-color ${FAST}` as TransitionProp;

// List rows rise 8px and fade in; the first few stagger, the rest arrive
// together so a long list never makes the user wait. Reduced motion: no travel,
// no delay, no duration.
export const ROW_RISE = { distance: 8, stagger: 40, maxStaggered: 8 } as const;

export function rowEntrance(index: number, reducedMotion: boolean) {
  if (reducedMotion) return { distance: 0, duration: 0, delay: 0 };
  return {
    distance: ROW_RISE.distance,
    duration: duration.base,
    delay: Math.min(index, ROW_RISE.maxStaggered) * ROW_RISE.stagger,
  };
}
